export default [
  [`Размеры`, `S`, `M`, `L`],
  [`Ширина, см`, `20`, `22`, `24`],
  [`Высота, см`, `10`, `12`, `14`]
];
